import HalfPriceTraffic from "@components/HalfPriceTraffic";
import Tooltip from "@components/Tooltip";
import ArrowBottom from "assets/svg/arrow-bottom.svg";
import Close from "assets/svg/close.svg";
import Exam from "assets/svg/courses/exam.svg";
import File from "assets/svg/courses/file.svg";
import Link from "assets/svg/courses/link.svg";
import OnlineCourse from "assets/svg/courses/online-course.svg";
import Pdf from "assets/svg/courses/pdf.svg";
import Practice from "assets/svg/courses/practice.svg";
import Lock from "assets/svg/details/lock.svg";
import Play from "assets/svg/play.svg";
import { DisplayType } from "interfaces";
import React, { FC, Fragment, useState } from "react";
import { sortArrayByOrder } from "src/utils";

import { Title } from "..";
import Modal from "../Modal";
import style from "./styles.module.css";

type Props = {
  data: any;
};

export const getFileIcon = (type: number) => {
  switch (type) {
    case 0:
      return <Play />;
    case 1:
      return <Pdf className="p-1" />;
    case 2:
      return <File className="p-1" />;
    case 3:
      return <Link className="p-1" />;
    case 4:
      return <OnlineCourse className="p-1" />;
    case 5:
      return <Practice className="p-1" />;
    case 6:
      return <Exam className="p-1" />;
  }
};

const Courses: FC<Props> = ({ data }) => {
  const [isShowVideoModal, setIsShowVideoModal] = useState({
    bool: false,
    url: "",
  });

  const handleCourseClick = (
    type: number,
    url: string,
    displayTypeFile: number
  ) => {
    switch (type) {
      case 0:
        displayTypeFile == DisplayType.Public &&
          setIsShowVideoModal({ bool: true, url });
        break;
      default:
        return;
    }
  };
  return (
    <>
      <Modal
        visible={isShowVideoModal.bool}
        onClose={() => setIsShowVideoModal((prev) => ({ ...prev, bool: true }))}
        className="h-screen w-screen"
      >
        <div className="relative mx-auto h-60 w-10/12 rounded bg-black md:h-96 md:w-8/12 xl:h-190">
          <video
            controls
            src={isShowVideoModal.url}
            className="h-full w-full"
          />
          <Close
            onClick={() =>
              setIsShowVideoModal((prev) => ({ ...prev, bool: false }))
            }
            className="absolute top-5 left-5 cursor-pointer fill-white"
          />
          <HalfPriceTraffic
            classes="absolute top-[1rem] right-[1rem] z-50 rounded"
            type="VIDEO"
            spaces="pr-2 md:pr-4 !ml-2"
            text="هزینه اینترنت مصرفی : نیم‌بها"
          />
        </div>
      </Modal>
      <div
        className={`h-auto rounded bg-white px-3 py-5 shadow-md transition-all md:p-5`}
        style={{
          contain: "content",
        }}
      >
        <div
          className={`relative transition-all`}
          style={{ contain: "content" }}
        >
          <Title
            type="DOT"
            title="سرفصل‌ها و جلسات دوره"
            wrapperClass="text-black-550 mb-5"
          />
          <div className="w-full space-y-[10px]">
            {sortArrayByOrder(data, "order")?.map(
              (course: any, index: number) => (
                <Fragment key={JSON.stringify(course?.id)}>
                  <details
                    className={`${
                      course?.files?.length !== 0
                        ? style.details
                        : style.emptyDetails
                    }  text-xs md:text-sm`}
                  >
                    <summary className={style.summary}>
                      <div className="flex w-full justify-between">
                        <div className="flex">
                          <div className="w-6 border-l border-blue-550 md:w-10">
                            {index + 1}
                          </div>
                          <span className="mr-2 md:mr-5">{course?.title}</span>
                        </div>
                        <div className="flex">
                          <span className="ml-1 md:ml-3"></span>
                          {course?.displayType == DisplayType.Soon ? (
                            "به زودی"
                          ) : (
                            <ArrowBottom className={style.arrow} />
                          )}{" "}
                        </div>
                      </div>
                    </summary>
                    {course?.files?.length !== 0 && (
                      <ul className="space-y-[10px]">
                        {sortArrayByOrder(course?.files, "order")?.map(
                          (file: any) => (
                            <div className="mx-5 mt-4 ">
                              <Tooltip
                                text="این فایل، پس از اضافه کردن آن به داشبورد، برای شما مخاطب عزیز، فعال و در داشبورد قابل مشاهده خواهد شد."
                                stickBottom={true}
                              >
                                <li
                                  key={JSON.stringify(file.id)}
                                  onClick={() =>
                                    handleCourseClick(
                                      file?.fileType,
                                      file.url,
                                      file?.displayType
                                    )
                                  }
                                  className="flex cursor-pointer items-center justify-between rounded bg-white p-[10px] text-xs leading-normal shadow md:text-sm"
                                >
                                  <div className="flex items-center">
                                    <div className={style.bgIcon}>
                                      {file?.fileType == 0 &&
                                      file?.displayType !== 2 ? (
                                        <Lock />
                                      ) : (
                                        getFileIcon(file?.fileType)
                                      )}
                                    </div>
                                    <span className="mr-2 md:mr-5">
                                      {file?.title}
                                    </span>
                                  </div>
                                </li>
                              </Tooltip>
                            </div>
                          )
                        )}{" "}
                      </ul>
                    )}{" "}
                  </details>
                </Fragment>
              )
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Courses;
